import React, { useEffect, useState } from "react";
import { Layout, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import "./HeaderComponent.css";
import MaitaiLogo from "./assets/maitai_logo_light_transparent.svg";

// Define an interface for the component props
interface HeaderComponentProps {
    chooseApplicationRef: React.MutableRefObject<any>;
    onRefresh: () => void;
}

const HeaderComponent: React.FC<HeaderComponentProps> = ({ chooseApplicationRef, onRefresh }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="header-container">
            <div className={`leftSection ${isMobile ? "mobile" : ""}`}>
                <img 
                    src={MaitaiLogo} 
                    className="logo-image"
                    alt="Maitai Logo"
                />
                <div ref={chooseApplicationRef} />
            </div>
            <div className="rightSection">
                <Button 
                    type="text"
                    icon={<ReloadOutlined />}
                    onClick={onRefresh}
                    title="Clear messages and start new session"
                />
            </div>
        </div>
    );
}

export default HeaderComponent;
